import styled from "styled-components";

// this spacer is very simple
// extentions are possible in the future...
export const Spacer = styled.div`
  flex: 1;
`;
